import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "layoutAuthentication" }
const _hoisted_2 = { id: "layoutAuthentication_content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-5 text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", null, " Error 404 Page Not Found ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                class: "btn btn-success",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Regresar al Inicio "),
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}